import { createRoot } from "react-dom/client";
import { Root } from "@/components/root";

import "./index.css";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(<Root />);
